export default __webpack_public_path__ + "static/media/codequiz_screenshot.3401fc0a.jpg";